// import Swiper JS
import Swiper from "swiper";
import { Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".swiper-1", {
    loop: false,
    slidesPerView: 1.1,
    grabCursor: false,
    spaceBetween: 16,
    modules: [Navigation],
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      991: {
        spaceBetween: 40,
        slidesPerView: 2.5,
      },
    },
  });
});
